import React from 'react';
import { useTimezone } from '@uplift/contexts';
import { DatePicker, DatePickerProps } from '../../../../Inputs/DatePicker';
import { CalendarDateService } from '@uplift/services';
import { useFormContext } from '../AddSessionForm.types';
import { DateFormats } from '@uplift/constants';


export type AppointmentDateInputProps = {
  name: string;
  label?: string;
  disabled?: boolean;
  TextFieldComponent?: DatePickerProps['TextFieldComponent'];
};


export const AppointmentDateInput: React.VFC<AppointmentDateInputProps> = ({ name, label, disabled, TextFieldComponent }) => {
  const timezone = useTimezone();
  const formikContext = useFormContext();

  const minMaxProps = React.useMemo(() => {
    const dt = CalendarDateService.date().tz(timezone);

    return {
      minDate: dt.startOf('day'),
      maxDate: dt.add(180, 'days'),
    };
  }, [ timezone ]);

  const date = formikContext.values.date;
  const startTime = formikContext.values.startTime;

  React.useEffect(() => {
    if (!startTime || !date) {
      return;
    }
    const start = CalendarDateService.date(startTime).tz(timezone);
    const dateObj = CalendarDateService.date.tz(date, DateFormats.ISO_DATE, timezone);
    const dateStr = dateObj.tz(timezone).date();
    const monthStr = dateObj.tz(timezone).month();
    const yearStr = dateObj.tz(timezone).year();

    if (
      dateStr === start.date()
      && monthStr === start.month()
      && yearStr === start.year()
    ) {
      return;
    }

    const newStart = start
      .set('date', dateStr)
      .set('month', monthStr)
      .set('year', yearStr);
    const newStartFormatted = newStart.format();

    formikContext.setFieldValue('startTime', newStartFormatted);
  }, [ date, timezone, startTime ]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <DatePicker
      valueFormat={DateFormats.ISO_DATE}
      showKeyboardPickerButton={false}
      disabled={disabled}
      TextFieldComponent={TextFieldComponent}
      // showToolbar={false}
      name={name}
      label={label}
      format="dddd, MMMM D"
      {...minMaxProps}
    />
  );
};
